import { useEffect } from 'react'
import { useRouteError } from 'react-router-dom'
import { Path } from '@/routes/paths'
import { useRouteNavigate } from '@features/navigation/hooks/useRouteNavigate'
import { ErrorFallback } from '@/features/shared/components/ErrorBoundary'

export default function RouteErrorBoundary() {
  const error = useRouteError()
  const navigate = useRouteNavigate()

  useEffect(() => {
    console.error('[RouteErrorBoundary] Uncaught route error:', error)
  }, [error])

  return (
    <ErrorFallback onReset={() => navigate(Path.home, { replace: true })} resetLabel="Go to Home" />
  )
}
